import type { PromotionChannelKind } from "@/types/sms";

const CHANNEL_LABEL: Record<PromotionChannelKind, string> = {
  phone: "Call in order",
  in_store: "Dine-in",
  online: "Order online",
};

interface OfferPreviewProps {
  mode: "offer";
  title: string;
  description?: string | null;
  terms: string;
  validThrough?: Date | null;
  enabledChannels: PromotionChannelKind[];
}

interface SmsPreviewProps {
  mode: "sms";
  body: string;
  imageUrl?: string | null;
}

type PhonePreviewProps = OfferPreviewProps | SmsPreviewProps;

/** A phone-frame preview of either the offer card or an SMS composer bubble. */
export function PhonePreview(props: PhonePreviewProps) {
  return (
    <div className="mx-auto w-full max-w-[280px] rounded-[2rem] border-8 border-foreground/10 bg-background p-3 shadow-sm">
      <div className="min-h-[420px] rounded-2xl bg-muted/40 p-3">
        {props.mode === "sms" ? (
          <div className="flex justify-end">
            <div className="max-w-[85%] rounded-2xl rounded-tr-sm bg-action-primary px-3 py-2 text-sm text-primary-foreground">
              {props.imageUrl && (
                <img src={props.imageUrl} alt="" className="mb-2 max-h-32 w-full rounded-lg object-cover" />
              )}
              <span className="whitespace-pre-wrap">{props.body || "Your message preview appears here."}</span>
            </div>
          </div>
        ) : (
          <div className="rounded-xl border border-border bg-card p-3 text-card-foreground">
            <div className="mb-1 text-[10px] font-medium uppercase tracking-wide text-muted-foreground">
              Mountain Mike&apos;s Pizza
            </div>
            <h3 className="text-sm font-semibold">{props.title || "Your promotion title"}</h3>
            {props.description && <p className="mt-1 text-xs text-muted-foreground">{props.description}</p>}
            <p className="mt-2 text-[11px] text-muted-foreground">{props.terms}</p>
            {props.validThrough && (
              <p className="mt-1 text-[11px] text-muted-foreground">
                Valid through {props.validThrough.toLocaleDateString()}
              </p>
            )}
            <div className="my-3 border-t border-border" />
            <p className="mb-2 text-xs font-medium">Select a redemption method</p>
            <div className="space-y-2">
              {props.enabledChannels.length === 0 && (
                <p className="text-xs text-muted-foreground">Turn on a redemption method to preview it.</p>
              )}
              {props.enabledChannels.map((channel) => (
                <button
                  key={channel}
                  type="button"
                  className="w-full rounded-lg bg-action-primary px-3 py-2 text-xs font-medium text-primary-foreground"
                  disabled
                >
                  {CHANNEL_LABEL[channel]}
                </button>
              ))}
            </div>
            <p className="mt-3 text-[10px] text-muted-foreground">
              You&apos;ll have 1 hour to purchase once you tap your redemption method above.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
